/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'cancelled': {
    width: 22,
    height: 22,
    viewBox: '0 0 22 22',
    data: '<g _fill="#213F6B" fill-rule="nonzero"><path pid="0" d="M20.9 2.2h-2.2V1.1a1.1 1.1 0 00-2.2 0v1.1h-11V1.1a1.1 1.1 0 00-2.2 0v1.1H1.1A1.1 1.1 0 000 3.3v17.6A1.1 1.1 0 001.1 22h19.8a1.1 1.1 0 001.1-1.1V3.3a1.1 1.1 0 00-1.1-1.1zm-1.1 17.6H2.2v-11h17.6v11zm0-13.2H2.2V4.4h17.6v2.2z"/><path pid="1" d="M8.019 17.281a1.1 1.1 0 001.562 0L11 15.851l1.419 1.43a1.1 1.1 0 001.562 0 1.1 1.1 0 000-1.562l-1.43-1.419 1.43-1.419a1.105 1.105 0 10-1.562-1.562L11 12.749l-1.419-1.43a1.105 1.105 0 10-1.562 1.562l1.43 1.419-1.43 1.419a1.1 1.1 0 000 1.562z"/></g>'
  }
})
